/* tslint:disable */
/* eslint-disable */
/**
 * attachmentAV
 * An SDK to integrate virus and malware scan capabilities into JavaScript / TypeScript applications. Scan files for viruses, trojans, and other kinds of malware with attachmentAV powered by Sophos.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UsageQuota
 */
export interface UsageQuota {
    /**
     * 
     * @type {number}
     * @memberof UsageQuota
     */
    limit: number;
    /**
     * 
     * @type {string}
     * @memberof UsageQuota
     */
    period: string;
}

/**
 * Check if a given object implements the UsageQuota interface.
 */
export function instanceOfUsageQuota(value: object): value is UsageQuota {
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('period' in value) || value['period'] === undefined) return false;
    return true;
}

export function UsageQuotaFromJSON(json: any): UsageQuota {
    return UsageQuotaFromJSONTyped(json, false);
}

export function UsageQuotaFromJSONTyped(json: any, ignoreDiscriminator: boolean): UsageQuota {
    if (json == null) {
        return json;
    }
    return {
        
        'limit': json['limit'],
        'period': json['period'],
    };
}

export function UsageQuotaToJSON(json: any): UsageQuota {
    return UsageQuotaToJSONTyped(json, false);
}

export function UsageQuotaToJSONTyped(value?: UsageQuota | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'limit': value['limit'],
        'period': value['period'],
    };
}

